import gql from 'graphql-tag';

export const schema = gql`
  query ListUserPublications(
    $nameKey: String!
    $descriptionKey: String!
    $lastKnownStepKey: String!
  ) {
    listUserPropertyListingPublications {
      publications {
        id
        status {
          type
          since
        }
        authors {
          id
          role
        }
        name: tag(key: $nameKey) {
          value
        }
        description: tag(key: $descriptionKey) {
          value
        }
        lastKnownStep: tag(key: $lastKnownStepKey) {
          value
        }
        plainAddress: attribute(key: "basic_information/address") {
          plainAddress {
            value
            details
          }
        }
        createdAt
        updatedAt
      }
    }
  }
`;
